// extracted by mini-css-extract-plugin
export default {"page":"page__ludVm","header":"header__VhFXJ","content":"content__kIsDe","title":"title__2CPQl","header-actions":"header-actions__bwLBk"};